import { render, staticRenderFns } from "./errorLayout.vue?vue&type=template&id=eff9337c&"
import script from "./errorLayout.vue?vue&type=script&lang=js&"
export * from "./errorLayout.vue?vue&type=script&lang=js&"
import style0 from "./errorLayout.vue?vue&type=style&index=0&id=eff9337c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports